import type { WThemeSearchRequest, WThemeSearchView } from '@zola/svc-web-api-ts-client';
import ApiService from '@zola-helpers/client/dist/es/http/api';

const routePath = `/web-api/v2/theme/search/faceted`;

export const facetedThemeSearch = async (request: WThemeSearchRequest): Promise<WThemeSearchView> =>
  ApiService.post<WThemeSearchView>(`${routePath}`, request);
